import { ReturnRequestLineItemDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@babackapp/ui/components/dropdown-menu";
import { PropsWithChildren } from "react";

type ResolutionType = ReturnRequestLineItemDto["resolution"];
type ResolutionSelectProps = {
  value: ResolutionType;
  editable: boolean;
  onChange?: (value: ResolutionType) => void;
};

export default function ResolutionSelect({
  onChange,
  children,
  editable,
}: PropsWithChildren<ResolutionSelectProps>) {
  const t = useTranslation();
  if (!onChange || !editable) return children;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger>{children}</DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuLabel>
          {t("returnDetail.confirmModal.chooseResolution")}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onSelect={() => onChange("refund")}
          data-cy="select-resolution-option-refund"
        >
          {t("misc.refund")}
        </DropdownMenuItem>
        <DropdownMenuItem
          onSelect={() => onChange("discount")}
          data-cy="select-resolution-option-discount"
        >
          {t("misc.discount")}
        </DropdownMenuItem>
        <DropdownMenuItem
          onSelect={() => onChange("exchange")}
          data-cy="select-resolution-option-exchange"
        >
          {t("misc.exchange")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
